module.exports = __webpack_public_path__ + "img/samsung-galaxy-book-s-2.f6ba445.jpg";